import React, { useEffect, useState } from "react";

/**
 * Mobile splash screen — visible for ~1s on first load per session.
 * Displays the official Mabuhay Capital Lending logo (gold M in circle
 * with MABUHAY / CAPITAL LENDING / Trusted. Reliable. Discreet.).
 */
export default function SplashScreen() {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const alreadyShown =
    typeof window !== "undefined" &&
    window.sessionStorage &&
    window.sessionStorage.getItem("mcl_splash_shown") === "1";

  const [visible, setVisible] = useState(isMobile && !alreadyShown);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const t1 = setTimeout(() => setFading(true), 900);
    const t2 = setTimeout(() => {
      setVisible(false);
      try {
        window.sessionStorage.setItem("mcl_splash_shown", "1");
      } catch (e) {}
    }, 1200);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="mobile-splashscreen"
      className={`fixed inset-0 z-[9999] md:hidden flex flex-col items-center justify-center transition-opacity duration-300 ${
        fading ? "opacity-0" : "opacity-100"
      }`}
      style={{
        background:
          "radial-gradient(circle at 50% 30%, #12326b 0%, #0A1F44 55%, #060f25 100%)",
      }}
    >
      <img
        src="/brand/logo.png"
        alt="Mabuhay Capital Lending"
        style={{ width: "min(72vw, 320px)", height: "auto" }}
        className="drop-shadow-2xl"
      />
      <div className="mt-6 h-1 w-32 rounded-full bg-white/10 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-amber-400 to-amber-200"
          style={{ animation: "mclSplash 1s ease-out forwards" }}
        />
      </div>
      <style>{`
        @keyframes mclSplash {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>
    </div>
  );
}
